import React, { Component } from "react";
import "component/common/ModalHeader/styles.scss";
import { withTranslation } from "react-i18next";

import { ReactComponent as PreviousIcon } from "assets/icons/previous.svg";
import { ReactComponent as CloseIcon } from "assets/icons/close.svg";

class ModalHeader extends Component {
  render() {
    const { t } = this.props;

    return (
      <div className="common-modal-header row">
        <div className="col-auto">
          {this.props.onClickPrevious && (
            <span
              className="float-start prev-btn"
              data-testid={this.props.backButtonTestId}
              onClick={this.props.onClickPrevious}
            >
              <PreviousIcon width="34" />
            </span>
          )}
        </div>
        {this.props.title && (
          <div
            className={`col title d-flex align-items-center ${
              this.props.showTitle ? "fade-in" : ""
            }`}
          >
            <div className="action-name w-100 text-center">
              <span>{this.props.title}</span>
            </div>
          </div>
        )}
        {!this.props.title && <div className="col title" />}
        <div className="col-auto">
          {this.props.showCloseButton ? (
            <div className="text-end">
              <span
                className="btn close-btn"
                data-testid={this.props.closeButtonTestId}
                onClick={this.props.onClose || this.props.onCloseClickHandler}
                >
                {t("close")}
              </span>
            </div>             
          ) : (
            this.props.onCloseClickHandler && (
              <CloseIcon
                width="34"
                data-testid={this.props.closeButtonTestId}
                onClick={this.props.onCloseClickHandler}
              />
            )
          )}
        </div>
      </div>
    );
  }
}

export default withTranslation("translation")(ModalHeader);
